import React, { useEffect, useRef, useState } from 'react';
import './Header.css';
import mainLogo from './main_logo.svg';
import filterIcon from './filter.svg';
import { useUser } from '../../contexts/UserContext';
import { useLocation, useNavigate } from 'react-router-dom';

interface HeaderProps {
  onFilterClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onFilterClick }) => {
  const { user, loading, logout } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isEditor = !!user?.groups?.some((g) => g.name === 'Редактор');
  const menuRef = useRef<HTMLDivElement>(null);

  const getUserDisplayName = () => {
    if (loading) return 'Загрузка...';
    if (!user) return 'Гость';
    
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    
    if (firstName && lastName) {
      return `${lastName} ${firstName}`;
    } else if (firstName) {
      return firstName;
    } else if (lastName) {
      return lastName;
    } else {
      return user.username;
    }
  };

  const showFilterButton = (
    (
      location.pathname === '/lab-exam' ||
      location.pathname === '/welded-joint-exams' ||
      location.pathname === '/lab-exam/deleted' ||
      location.pathname === '/certificates' || 
      location.pathname === '/voluntary-certificates' ||
      location.pathname.startsWith('/declarations/') ||
      location.pathname.startsWith('/certificates/dynamics/')
    ) && onFilterClick
  );

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
    navigate('/auth');
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <img 
        src={mainLogo} 
        alt="Logo" 
        className="header__logo" 
        onClick={handleLogoClick}
      />
      <div className="header__user-info" ref={menuRef}>
        <span className="header__user-name">{getUserDisplayName()}</span>
        <button className="header__rect-toggle" onClick={handleToggleMenu} aria-haspopup="true" aria-expanded={isMenuOpen} title="Открыть меню">
          <svg width="20" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 16.8C11.3 16.8 10.6 16.53 10.07 16L3.55002 9.48001C3.26002 9.19001 3.26002 8.71001 3.55002 8.42001C3.84002 8.13001 4.32002 8.13001 4.61002 8.42001L11.13 14.94C11.61 15.42 12.39 15.42 12.87 14.94L19.39 8.42001C19.68 8.13001 20.16 8.13001 20.45 8.42001C20.74 8.71001 20.74 9.19001 20.45 9.48001L13.93 16C13.4 16.53 12.7 16.8 12 16.8Z" fill="currentColor" />
          </svg>
        </button>
        {isMenuOpen && (
          <div className="header__dropdown" role="menu">
            <button type="button" className="header__logout-btn" onClick={handleLogout} role="menuitem">Выйти</button>
          </div>
        )}
      </div>
      {showFilterButton && (
        <button className="header__filter-btn" onClick={onFilterClick}>
          <img src={filterIcon} alt="Filter" className="header__filter-icon" />
        </button>
      )}
    </header>
  );
};

export default Header;
